import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Fi = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { fill: "#FFFFFF", width: "21", height: "14" }),
    React.createElement("polygon", { fill: "#003680", points: "21,5.333 8.531,5.333 8.531,0 5.25,0 5.25,5.333 0,5.333 0,8.889 5.25,8.889 5.25,14\n\t8.531,14 8.531,8.889 21,8.889 " })), 'Fi', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Fi;
